import styled from 'styled-components';
import StarJedi1 from '../../Assets/Font/Star_Jedi/starjedi/Starjedi.ttf';


export const Container = styled.div`
    align-items: stretch;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 120%;
    background-color: #00384a;
    @font-face {
        font-family: "StarJedi1";
        src: url(${StarJedi1});
    }
`;

export const Form = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    place-content: center;
    width: 100%;
    height: 100vh;
    overflow: auto;
    img {
        width: 200px;
    }
    h2{
        font-size: 20px;
        margin-top: -15px;
        margin-right: -100px;
        font-family: "StarJedi1";
        font-weight: 200;
        color: #ffffff
    }
    h6 {
        margin: 35px 0px 0px 0px;
        font-family: 'Roboto',sans-serif;
        font-weight: 400;
        font-size: 20px;
        text-justify: auto;
        color: #ffffff;
        text-align: center;
        width: 350px;
        height: 24px;
    }
`;
